export const environment = {
  production: false,
  apiUrl: 'https://api-managment-digitalizcija.azure-api.net/isbp-development/',
  keycloak: {
    clientId: 'isbp-employees-bike',
    realm: 'isbp-test',
    url: ' https://wa-euwe-keycloak-test-01.azurewebsites.net/',
    logoutUrl: 'https://zealous-flower-07995ae03.6.azurestaticapps.net/logout',
  },
  useApim: true,
  secret: '4832f02c7fcd44658fecdc7cbbce42be',
};
